import { useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import CompetitorsSection from '../components/CompetitorsSection';
import SfGamingSection from '../components/SfGamingSection';
import ArchiveSection from '../components/ArchiveSection';
import { applyPageMeta } from '../lib/seo';
import { PAGE_META } from '../lib/routeMeta';

export default function HomePage() {
  useEffect(() => {
    applyPageMeta(PAGE_META.home);
  }, []);

  return (
    <>
      <HeroSection />
      <CompetitorsSection />
      <SfGamingSection />
      <ArchiveSection />
    </>
  );
}
